import { defineComponent as _defineComponent } from 'vue'
import { ITaskResponse } from '@/Interfaces';
  import { UserDataSource } from '@/Sources';
  import { useToken } from '@/useToken';
  import { useUser } from '@/useUser';
  import { AjaxHelper, IPaginatedList } from '@samc/common';
  import { IEntityData } from '@samc/taskmanagement-ui';
  import { onMounted, ref, watch } from 'vue';
  import { IPackageEntity, handleGetEntityName, handleEntityClick } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MyTasksPage',
  props: {
    verificationToken: { type: String, required: true },
    apiRoot: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as {
    verificationToken: string,
    apiRoot: string
  };

  

  const tab = ref('assigned');
  const { token } = useToken();
  const { user } = useUser();

  const entityMap = new Map<number, IPackageEntity>();
  const loadedEntities = ref<IEntityData[]>([]);

  const loadEntities = async () => {
    const helper = new AjaxHelper('/datasource/packagesbasic', '', '', null);
    const result = await helper.getData<IPaginatedList<IPackageEntity>>();
    result.items.forEach(entity => {
      if (entity?.id !== null && entity?.id !== undefined) {
        entityMap.set(entity.id, entity);
      }
    });
    loadedEntities.value = result.items;
  };

  onMounted(() => {
    loadEntities();
  });

  const onGetEntityName = (evt: CustomEvent) => handleGetEntityName(entityMap, evt);
  const onEntityClick = (evt: CustomEvent) => handleEntityClick(entityMap, evt);

  const assignedGrid = ref<HTMLTmTaskGridElement | null>(null);
  const watchingGrid = ref<HTMLTmTaskGridElement | null>(null);
  const assignedCount = ref(-1);
  const watchingCount = ref(-1);

  const setValue = (evt: CustomEvent<string>) => {
    tab.value = evt.detail;
  };

  watch([assignedGrid, user], ([newGrid, newUser]) => {
    if (newGrid === null || newUser === null) {
      return;
    }
    newGrid.filters = { assignedTo: newUser.email ?? '' };
    newGrid.userSource = new UserDataSource();
    newGrid.entitySource = loadedEntities.value;
    newGrid.currentUser = newUser;
  });

  watch([watchingGrid, user], ([newGrid, newUser]) => {
    if (newGrid === null || newUser === null) {
      return;
    }
    newGrid.filters = { watcher: newUser.email ?? '' };
    newGrid.userSource = new UserDataSource();
    newGrid.entitySource = loadedEntities.value;
    newGrid.currentUser = newUser;
  });

  watch(loadedEntities, (entities) => {
    if (assignedGrid.value !== null) {
      assignedGrid.value.entitySource = entities;
    }
    if (watchingGrid.value !== null) {
      watchingGrid.value.entitySource = entities;
    }
  });

  watch(token, async (newToken) => {
    const service = new AjaxHelper(props.apiRoot, props.verificationToken, null, newToken);
    const details = await service.getData<ITaskResponse<{ myTasksCount: number, watcherTasksCount: number }>>('/Task/DetailsCount');

    if (details.success) {
      assignedCount.value = details.data.myTasksCount;
      watchingCount.value = details.data.watcherTasksCount;
    } else {
      window.showAlert?.warning('Failed to retrieve task details count.', 'The following errors occurred:', true, details.message);
    }
  }, { immediate: true });

return { __sfc: true,props, tab, token, user, entityMap, loadedEntities, loadEntities, onGetEntityName, onEntityClick, assignedGrid, watchingGrid, assignedCount, watchingCount, setValue }
}

})